module.exports = __webpack_public_path__ + "static/media/bus-icon.f0131b6a.svg";